<div [ngClass]="{'full-width': !expand}" class="header">
  <div class="menu">
    <span (click)="toggle()" class="material-icons">
      menu
    </span>
  </div>
  <div class="actions">
    <div class="user-x">
      <span (click)="listenForClose($event)" class="user-name pointor">{{name | titlecase}}</span>
      <div (click)="listenForClose($event)">
        <span class="material-icons">
          person
        </span>
        <!-- <div *ngIf="profileImg" class="user-dp">
          <img [src]="profileImg ? profileImg : dummyImg" alt="Profile-Img" />
        </div> -->
        <div *ngIf="openProfileMenu" class="profile-options">
          <!-- <span [routerLink]="['../profile/myprofile']">My Profile</span> -->
          <span [routerLink]="['../profile/changepassword']">Change
            Password</span>
          <span (click)="logout()" style="color: var(--theme-secondary);">Logout</span>
        </div>
      </div>
    </div>
  </div>
</div>